import { useInfoCorporate } from './useInfoCorporate'

export default useInfoCorporate
